//var $ = require('jquery');
var phpjs = require('./phpjs');

initializeSemanticPopup();

function initializeSemanticPopup() {
    /**
     * Semantic UI Popup
     * @see {@link https://semantic-ui.com/modules/popup.html}
     */
    $('.popup').each(function(i, el){
        var $el = $(el);
        /*
         top left
         top center
         top right
         right center
         bottom right
         bottom center
         bottom left
         left center
         @see http://semantic-ui.com/modules/popup.html#positioning
         */
        $el.popup({
            position: $el.hasAttr('data-position') ? $el.attr('data-position') : 'bottom center',
            target: el,
            // Не скрывающаяся при наведении подсказка с классом "popup-hoverable"
            hoverable: $el.hasClass('popup-hoverable')
        });
        if ($el.hasClass('popup-modal')) {
            $el.css({
                cursor: 'pointer'
            });
            var
                modalNode = $('<div class="ui modal"><i class="close icon"></i><div class="content" style="display: block;"></div></div>')
                , dataContent
                ;
            //в новом семантике аттрибут для html - data-html, тем не менее на сайте может использоваться старый аттрибут или аттрибут для сырого текста, оставляем условие.
            if ($el.hasAttr('data-html')) {
                dataContent = phpjs.htmlspecialchars_decode($el.attr('data-html'));
            }

            if ($el.hasAttr('data-content')) {
                dataContent = phpjs.htmlspecialchars_decode($el.attr('data-content'));
            }

            if (dataContent) {

                modalNode.find('.content').html(dataContent);

                function onClick() {
                    modalNode.modal('show');
                }

                $el.on('click', onClick);
            }
        }
    });
}

/**
 * Semantic UI Accordion
 * @see {@link https://semantic-ui.com/modules/accordion.html}
 */
$('.ui.accordion').accordion({
    // Отмена анимации прозрачности содержимого (влияет на быстродействие)
    animateChildren: false
});
/**
 * Раскрывающийся блок может иметь сообщение внутри заголовка по такой схеме:
 *
 * <div class="title">
 *     ...
 *     <div class="message">...</div>
 *     ...
 * </div>
 *
 * для которого отменяется действие родительского "click"
 */
$('.ui.accordion .title .message').on('click', function(e){
    e.stopPropagation();
});

/**
 Toggle mobile menu
 **/
$('#phone-toggle-menu .fa-reorder').click( function() {
    $('#header-menu').toggleClass('hide-on-phone').toggleClass('opened');
    return false;
});

// change shop view list/grid
$('.change-shop-view').click( function() {

    var target = $('#shop-posts-list');

    $('a.change-shop-view').removeClass('current');

    if( $(this).hasClass('view-grid') ) {
        target.removeClass('view-list').addClass('view-grid');
    }

    if( $(this).hasClass('view-list') ) {
        target.removeClass('view-grid').addClass('view-list');
    }

    $(this).addClass('current');

    //ellipsis.reInit();

    return false;
});

/**
 Header AJAX cart
 **/
$('header.small .my-cart').hover( function() {

    if( $('html').hasClass('mobile') ) {
        return false;
    }

    var link = $(this);

    if( link.hasClass('cart-opened') == false ) {

        link.addClass('cart-opened');
        $('#wproto-ajax-header-cart').fadeIn('fast');

    }

});

$('#wproto-ajax-header-cart').hover( function() {

}, function() {
    $(this).fadeOut('fast');
    $('header.small .my-cart').removeClass('cart-opened');
});

$('#wproto-close-ajax-cart').on( 'click', '#wproto-ajax-header-cart', function() {
    $('#wproto-ajax-header-cart').fadeOut('fast');
    $('header.small .my-cart').removeClass('cart-opened');
});

$(window).scroll(function(){
    $('#wproto-ajax-header-cart').fadeOut('fast');
    $('header.small .my-cart').removeClass('cart-opened');
});

// Header menu scrolling
navMenu();

function navMenu() {

    if( $('.big-header-wrapper').length && $('body').hasClass('template-home-one-page') == false ) {

        var menuTop = $('header.small');
        var el = $('.big-header-wrapper');
        var elpos_original = el.offset().top;
        var elpos_original_backup = elpos_original;

        $(window).scroll(function(){
            var elpos = el.offset().top;
            var windowpos = $(window).scrollTop();
            var finaldestination = windowpos;
            var body = $('body');
            if ($('.big-header-wrapper .add-to-cart').length) {
                elpos_original = elpos_original_backup + 400;
            }

            //if( $(window).width() > 100 ) {

                if(windowpos<=elpos_original) {
                    finaldestination = elpos_original;

                    el.removeClass('scrolled');
                    menuTop.removeClass('menu-scrolled');
                    body.removeClass('scrolling')

                } else {

                    if( body.hasClass('scrolling') == false ) {
                        body.addClass('scrolling');
                    }

                    if( el.hasClass('scrolled') == false ) {
                        el.addClass('scrolled');
                    }

                    if( menuTop.hasClass('menu-scrolled') == false ) {
                        menuTop.addClass('menu-scrolled');
                    }


                }
            //} else {
            //    el.removeClass('scrolled');
            //    menuTop.removeClass('menu-scrolled');
            //}
        });

        $( window ).resize(function() {
            if( $(window).width() < 899 ) {
                $('header.small, .big-header-wrapper').removeClass('menu-scrolled scrolled');
            }
        });

    }
    /*
     var moveBigHeaderToSideBar = function () {};

     if ($('body').hasClass('single-product') || $('body').hasClass('post-type-archive-product')) {
     var
     headerSmallContainer = $('header.small'),
     bigHeaderContainer = $('.big-header-wrapper'),
     sideBarP = $('.sidebar .bigHeaderAncor')
     ;

     moveBigHeaderToSideBar = function () {
     if( $(window).width() < 570 ) {
     if (bigHeaderContainer.attr('isMovedToSidebar') != 1) {
     sideBarP.after(bigHeaderContainer);
     bigHeaderContainer.attr('isMovedToSidebar' , '1');
     }
     } else {
     if (bigHeaderContainer.attr('isMovedToSidebar') == 1) {
     headerSmallContainer.after(bigHeaderContainer);
     bigHeaderContainer.attr('isMovedToSidebar' , '0');
     }
     }
     };

     //moveBigHeaderToSideBar();

     $( window ).resize(function() {
     if( $(window).width() < 899 ) {
     $('header.small, .big-header-wrapper').removeClass('menu-scrolled scrolled');
     }
     //moveBigHeaderToSideBar();
     });
     }
     */

};


// WEBPACK FOOTER //
// ./assets/javascript/common.js